var ADDRESS_TARGETS = /* @__PURE__ */ ((ADDRESS_TARGETS2) => {
  ADDRESS_TARGETS2["COUNTRY"] = "country";
  ADDRESS_TARGETS2["SUBDIVISION"] = "subdivision";
  ADDRESS_TARGETS2["CITY"] = "city";
  ADDRESS_TARGETS2["ADDRESS_LINE"] = "addressLine";
  ADDRESS_TARGETS2["ADDRESS_LINE_2"] = "addressLine2";
  ADDRESS_TARGETS2["POSTAL_CODE"] = "postalCode";
  ADDRESS_TARGETS2["STREET_NAME"] = "streetName";
  ADDRESS_TARGETS2["STREET_NUMBER"] = "streetNumber";
  ADDRESS_TARGETS2["APARTMENT"] = "apartment";
  return ADDRESS_TARGETS2;
})(ADDRESS_TARGETS || {});
function fromAtlasAddress(address, isMultilineAddressField) {
  const {
    country,
    subdivision,
    city,
    addressLine,
    streetAddress,
    addressLine2,
    postalCode
  } = address;
  const partial = {};
  if (isMultilineAddressField) {
    if (country) {
      partial.country = country;
    }
    if (subdivision) {
      partial.subdivision = subdivision;
    }
    if (city) {
      partial.city = city;
    }
    if (addressLine) {
      partial.addressLine = addressLine;
    } else if (streetAddress?.formattedAddressLine) {
      partial.addressLine = streetAddress?.formattedAddressLine;
    }
    if (addressLine2) {
      partial.addressLine = addressLine2;
    }
    if (postalCode) {
      partial.postalCode = postalCode;
    }
    if (streetAddress?.apt) {
      partial.apartment = streetAddress?.apt;
    }
    if (streetAddress?.name) {
      partial.streetName = streetAddress?.name;
    }
    if (streetAddress?.number) {
      partial.streetNumber = streetAddress.number;
    }
  } else {
    if (country) {
      partial.country = country;
    }
    if (subdivision) {
      partial.subdivision = subdivision;
    }
    if (city) {
      partial.city = city;
    }
    if (addressLine) {
      partial.address_line = addressLine;
    } else if (streetAddress?.formattedAddressLine) {
      partial.address_line = streetAddress?.formattedAddressLine;
    }
    if (addressLine2) {
      partial.address_line = addressLine2;
    }
    if (postalCode) {
      partial.postal_code = postalCode;
    }
    if (streetAddress?.apt) {
      partial.apartment = streetAddress?.apt;
    }
    if (streetAddress?.name) {
      partial.street_name = streetAddress?.name;
    }
    if (streetAddress?.number) {
      partial.street_number = streetAddress.number;
    }
  }
  return partial;
}
export {
  ADDRESS_TARGETS,
  fromAtlasAddress
};
//# sourceMappingURL=address.js.map
